import FieldTimeOfDay from "../../../generic/datetime/time-of-day/time-of-day"
import FieldConfig from "../../../proto/field-config"
import FieldTimeReportTimeOfDay_TableCell from "./render/table/table-cell"
import TimeReport from "../../../../model2/time-report/time-report"

export default class FieldTimeReportTimeOfDay extends FieldTimeOfDay {

    constructor(config: FieldConfig) {
        super(config)

        this.renderComponents.tableCell = FieldTimeReportTimeOfDay_TableCell
    }

    canEdit(model: TimeReport):boolean {
        // fake guesstimates and placeholders have no row on the server - there is nothing to update
        if (model.isFakeGuesstimate || model.isPlaceholder) {
            return false
        }

        return model.canEdit
    }
}
